import * as React from 'react';
import { ReactNode } from 'react';
import ResizeSensor from 'resize-sensor';

interface ResizeObserverProps {
  onResize?:() => void;
  children?: ReactNode;
}

export class ResizeObserver extends React.PureComponent<ResizeObserverProps> {
  private sensor: ResizeSensor;
  private ref:React.RefObject<HTMLDivElement> = React.createRef();

  private handleResize = () => {
    this.props.onResize && this.props.onResize();
  };

  public componentDidMount () {
    this.sensor = new ResizeSensor(this.ref.current, this.handleResize);
  }

  public componentWillUnmount () {
    this.sensor.detach();
    this.sensor = null;
  }

  public render () {
    const { children } = this.props;
    return <div className={'resize-sensor'} ref={this.ref}>
      {children}
    </div>;
  }
}
